import { useLazyQuery } from '@apollo/client'
import { TestCountAnalytics, TestCountAnalyticsVariables } from '../../types'
import { TESTS_COUNT_ANALYTICS } from './operations'

export const useTestsCountAnalytics = () => {
  const testAnalyticsQuery = useLazyQuery<TestCountAnalytics, TestCountAnalyticsVariables>(
    TESTS_COUNT_ANALYTICS
  )

  return testAnalyticsQuery
}
